import * as ContactsActions from 'web-app/react/entities/contacts/actions';
import * as DocumentsActions from 'web-app/react/documents/actions';
import {FORM_NAME as InstitutionBasicInfoFormName} from 'web-app/react/institution/settings/info/institution-basic-info/institution-basic-info-form/constants';
import * as InviteContactsActions from 'web-app/react/invite-parents/actions';
import * as ChildProfileBasicInfoActions from 'web-app/react/profile/child-profile/basic-info/actions';

import {TrackingEvents} from './events';
import {type TrackingEvent} from './types';

/**
 * This file contains configurations for Redux event tracking (famlytics).
 */

/**
 * Use this as a key in a action payload to define which properties should
 * be sent alongside the event.
 *
 * Example action definition:
 * const {action: myAction} = createAction(MY_ACTION, () => ({
 *   [TRACK_ACTION_PAYLOAD_KEY]: {
 *     // ... some properties to track
 *   }
 *   }}
 * ))
 *
 */
export const TRACK_ACTION_PAYLOAD_KEY = 'trackingPayload';

/**
 * Add the action types you want to track here, and map them to
 * a human readable `Event`
 */
export const actionTypeToTrackingEventMap: Record<string, TrackingEvent> = {
    [ContactsActions.createChildContact.type]: TrackingEvents.CONTACT_OR_LOGIN_CREATED,
    [InviteContactsActions.assignRole.type]: TrackingEvents.CONTACT_OR_LOGIN_CREATED,
    [ContactsActions.updateChildContactAfterRoleUpdate.type]: TrackingEvents.CONTACT_OR_LOGIN_CREATED,
    [InviteContactsActions.assignRoles.type]: TrackingEvents.INVITE_CONTACTS,
    [ChildProfileBasicInfoActions.saveBasicInfo.type]: TrackingEvents.EDIT_CHILD_INFO,
    [DocumentsActions.deleteFileSuccess.type]: TrackingEvents.DOCUMENTS_FILE_DELETED,
};

/**
 * Add the redux form names here, that you want to track on submit, and map them to a
 * human readable `FormNameForTracking`
 */
export const reduxFormNamesToTrackingEventMap: {[key: string]: 'Get started: Institution basic info'} = {
    [InstitutionBasicInfoFormName]: 'Get started: Institution basic info',
};
